import React from "react";
import PropTypes from "prop-types";
import {
  varsomeClinicalUrl,
  varsomePremiumUrl,
} from "../../../common/helpers/Urls";
import { getVarsoUrl } from "../../../common/helpers/helpers";

const vasomeClinicalLink = `
  <a href=${varsomeClinicalUrl} target="_blank" >
    VarSome Clinical
  </a>
`;

const varsomePremiumLink = `
  <a href=${varsomePremiumUrl} target="_blank" >
    VarSome Premium
  </a>
`;

const getURL = (exacURL, linkText) =>
  `<a href=${getVarsoUrl(exacURL)}  target="_blank">
    ${linkText}
  </a>`;

export const ADDITIONAL_DATABASES_MESSAGES = {
  Cosmic: {
    description: `The ${getURL(
      "https://cancer.sanger.ac.uk/cosmic",
      "Catalogue of Somatic Mutations in Cancer (COSMIC)"
    )} contains information for this variant, available on ${vasomeClinicalLink} and API. It is also available on ${varsomePremiumLink} if you already have a COSMIC license.`,
  },
  CKB: {
    description: `The ${getURL(
      "https://www.jax.org/clinical-genomics/ckb",
      "Jackson Laboratory Clinical Knowledgebase (CKB)"
    )}  contains full curation for this variant, available on ${vasomeClinicalLink}.`,
  },
};

const AdditionalDatabasesMessage = ({ database }) => {
  return (
    <span
      data-testid="additional-databases-message"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: ADDITIONAL_DATABASES_MESSAGES[database]?.description,
      }}
    />
  );
};
AdditionalDatabasesMessage.displayName = "AdditionalDatabasesMessage";

AdditionalDatabasesMessage.propTypes = {
  database: PropTypes.string.isRequired,
};

export default AdditionalDatabasesMessage;
